import { useMedia } from 'react-use'

export type UseScreenSizeProps = { breakingPoint?: number }
export const useScreenSize = ({ breakingPoint }: UseScreenSizeProps = {}): 'mobile' | 'desktop' | 'unknown' => {
  breakingPoint = breakingPoint ?? 768

  const isMobile = useMedia(`(max-width: ${breakingPoint}px)`)
  const isDesktop = useMedia(`(min-width: ${breakingPoint}px)`)

  if (isMobile) {
    return 'mobile'
  }

  if (isDesktop) {
    return 'desktop'
  }

  return 'unknown'
}

export const useIsMobileScreenSize = (props: UseScreenSizeProps = {}) => {
  return useScreenSize(props) === 'mobile'
}

export const useIsDesktopScreenSize = (props: UseScreenSizeProps = {}) => {
  return useScreenSize(props) === 'desktop'
}
